import React from 'react';

import { Input, InputProps } from '@mantine/core';
import { localeData } from 'localization/localization-data';
import InputMask from 'react-input-mask';
import { Country, CountryEnum } from 'types/enums';

interface IPostalCodeInputProps extends Omit<InputProps, 'data' | 'rightSection'> {
  country: Country;
  formErrors?: React.ReactNode;
}

const PostalCodeInput = ({
  country = CountryEnum.USA,
  formErrors,
  ...inputProps
}: IPostalCodeInputProps): JSX.Element => {
  const label = localeData[country].copy.address.zipLabel;
  const mask = localeData[country].copy.address.zipInputMask;
  const placeholder = localeData[country].copy.address.zipPlaceholder;

  return (
    <Input.Wrapper>
      <Input.Label>{label}</Input.Label>
      <Input component={InputMask} mask={mask} placeholder={placeholder} {...inputProps} />
      {formErrors && <Input.Error>{formErrors}</Input.Error>}
    </Input.Wrapper>
  );
};

export default PostalCodeInput;
